<template>
  <div class="u-page" :class="[platform,showtranslateNav]">
    <div class="header-container">     <!--<slot name="nav" >-->
      <slot name="m-nav">
        <div class="header-inner">
          <slot name="m-nav-left">
            <button @click="back" class="iconfont  icon-leiappreturn m-nav-left"></button>
          </slot>
          <slot name="m-nav-center">
            <div class="title">
              {{title}}
            </div>
          </slot>
          <div class="m-nav-right">
            <slot name="m-nav-right">
            </slot>
          </div>
        </div>
      </slot>
    </div>
    <div class="content-container">
      <div class="content-container-mobile" style="height: 100%">
        <um-scroll ulHandleKey="u-page"
                   ref="umScroll"
                   :ulLoadNewText="ulLoadNewText"
                   :ulShowLoadNew="ulShowLoadNew"
                   :ulScrollbar="ulScrollbar"
                   :ulShowScrollBar="ulShowScrollBar"
                   :ulShowLoading="ulShowLoading"
                   :ulShowEmpty="ulShowEmpty"
                   :ulEmptyText="ulEmptyText"
                   :ulShowErr="ulShowErr"
                   :ulErrText="ulErrText"
                   @onULoadNew="onULoadNew"
                   :class="umscroll">
          <template slot="content">
            <slot name="content"></slot>
          </template>
        </um-scroll>
        <!--<cube-scroll :class="[umscroll]">-->
        <!--&lt;!&ndash;<slot name="content"></slot>&ndash;&gt;-->
        <!--</cube-scroll>-->
      </div>

    </div>
    <div class="footer-container">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import { getPlatform } from './../utils/platform'
  import { exitApp } from 'common/js/mobilePlugin'
  import UmScroll from 'common/components/mobile/umScroll/umScroll'

  export default {
    created () {
      this.platform = getPlatform().platform
      if (getPlatform().isMobile) {
        this.platform = `${this.platform} mobile`
      }
    },
    props: {
//       标题
      title: {
        type: String,
        default: '',
        required: false
      },
      umCanScroll: {
        type: Boolean,
        default: false
      },
      ulErrText: {
        type: String,
        default: ''
      },
      ulStopDefaultBack: {
        type: Boolean,
        default: false
      },
      ulShowLoadNew: {
        type: Boolean,
        default: false
      },
      ulLoadNewText: {
        type: String,
        default: ''
      },
      //       是否显示进度条淡入淡出效果
      ulScrollbar: {
        type: Boolean,
        default: true
      },
//      是否显示进度条，默认不显示
      ulShowScrollBar: {
        type: Boolean,
        default: false
      },
//      是否显示加载中
      ulShowLoading: {
        type: Boolean,
        defalut: false
      },
//      是否显示空页面
      ulShowEmpty: {
        type: Boolean,
        defalut: false
      },
      //      是否显示错误页面
      ulShowErr: {
        type: Boolean,
        defalut: false
      },
      ulEmptyText: {
        type: String,
        default: '没有数据'
      },
      ulLoadingText: {
        type: String,
        deault: '加载中...'
      },

//      是否使用加载更多
      ulShowLoadeMore: {
        type: Boolean,
        defalut: false
      },
//      设置加载更多文字
      ulLoadMoreText: {
        type: String,
        default: ''
      },
      ulLoadNoMoreText: {
        type: String,
        default: '没有更多数据'
      },
      ulShowNavTranslate: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
//       平台属性
        platform: ''
      }
    },
    methods: {
      back () {
        this.$emit('onMBack')
        if (!this.ulStopDefaultBack) {
          if (getPlatform().isMobile) {
            window.history.length > 1 ? this.$router.go(-1) : exitApp()
          } else {
            this.$router.back()
          }
        }
      },
      onULoadNew () {
        this.$emit('onULoadNew')
      },
      stopRefresh () {
        this.$refs.umScroll.stopRefresh()
      }
    },
    computed: {
      umscroll () {
        return this.umCanScroll ? 'um-page-scroll' : ''
      },
      showtranslateNav () {
        return this.ulShowNavTranslate ? 'nav-translate' : ''
      }
    },
    components: {
      UmScroll
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "./../stylus/variable.styl"
  .u-page
    padding: 0px 0px

  @media (max-width: 768px) {
    .content-container {
      max-width: 100%;
    }
  }

  .ios, .android
    position: absolute
    left: 0
    right: 0
    bottom: 0
    top: 0
    display: flex
    flex-direction: column
    > .content-container
      flex: 1
      overflow: auto
      position: relative
      .content-container-mobile
        position: absolute
        left: 0
        right: 0
        bottom: 0
        top: 0
        > .cube-scroll-wrapper
          > .cube-scroll-content
            height: 100%
            > .cube-scroll-list-wrapper
              height: 100%
        > .um-page-scroll
          > .cube-scroll-content
            height: auto
            min-height: 100% !important
            > .cube-scroll-list-wrapper
              height: auto
              min-height: 100% !important
    > .header-container
      > .header-inner
        display: flex
        justify-content: space-between
        align-items: center
        box-sizing border-box
        border-bottom: 1px solid #e3e3e9
        background: white
        position: relative
        .m-nav-right
          font-size: 0px
          margin-right: 8px
          i
            font-size: 22px
        .m-nav-left
          font-size: 22px !important
          height: 100%
          color: $nav-button-color
        .title
          /*text-align : left*/
          position: absolute
          bottom: 0
          top: 0
          display: flex
          align-items: center
          justify-content: center
          overflow: hidden
          font-size: $nav-title-size-mobile
          color: $nav-title-color-mobile
          white-space: nowrap
          overflow: hidden
          text-overflow: ellipsis
          left: 50px
          right: 50px

  .android
    .header-container
      > .header-inner
        min-height: $nav-button-height-android
        .m-nav-left, .m-nav-right button
          position relative
          z-index 2
          width: 36px
          height: $nav-button-height-android
          font-size: $font-size-medium
          margin-bottom: 1px

  .ios
    .header-container
      padding-top: $nav-height-ios-pading-t
      > .header-inner
        height: $public-height-custom
        .m-nav-left, .m-nav-right button
          position relative
          z-index 2
          width: 36px
          height: $public-height-custom
          font-size: $font-size-medium
          margin-bottom: 1px

  .nav-translate
    .header-inner
      border-bottom: none !important
    &.ios
      .content-container
        margin-top: -64px
    &.android
      .content-container
        margin-top: -56px
</style>



// WEBPACK FOOTER //
// src/common/components/u-page.vue